import Vue from "vue";
import Axios from "axios";
import router from "@/router";
import { displayInfo } from "@/utils/helpers";

import { backendAddress } from "@/utils/appSettings";

Axios.defaults.baseURL = backendAddress("/api");

const getStore = () => import("@/store");
import store from "@/store";
Axios.interceptors.request.use(config => {
  if (
    !config.url.toUpperCase().includes("GETSTATUSLOCALIZATIONS") &&
    !config.url.toUpperCase().includes("UTILITY")
  ) {
    setTimeout(() => {
      getStore().then(store => {
        store.default.dispatch("loading");
      });
    });
  }
  config.headers.common["Authorization"] =
    "Bearer " + sessionStorage.getItem("token");
  return config;
});

Axios.interceptors.response.use(
  response => {
    setTimeout(() => {
      getStore().then(store => {
        store.default.dispatch("loaded");
      });
    });
    return response;
  },
  error => {
    setTimeout(() => {
      getStore().then(store => {
        store.default.dispatch("loaded");
      });
    });
    if (error.response) {
      if (error.request.responseURL.toUpperCase().includes("LOCALES")) {
        Promise.reject(error);
        return;
      }
      if (error.response.status == 400) {
        if (error.response.data.message == "Błąd połączenia.") {
          router.push({
            path: "/connectionError"
          });
        }
        if (error.response.data.message == "LicenseNotValid") {
          router.push({
            path: "/Invalid"
          });
        }
        if (error.response.data.message == "PageIsNotEnable") {
          router.push({
            path: "/PageDisabled"
          });
        }
        if (error.response.data.message == "IPBLOCKED") {
          router.push({
            path: "/IpBlock/" + error.response.data.companyName
          });
        }
        //displayErrors(error);
      }
      // if (error.response.status == 401) {
      //   router.push({
      //     path: "/login"
      //   });
      // }
      if (error.response.status == 403) {
        setTimeout(() => {
          store.dispatch("logout");
        });
        router.push({
          path: "/forbidden"
        });
      }
      if (error.response.status == 404) {
        var url = error.request.responseURL.toUpperCase();
        if (
          !url.includes("/STATIC/") &&
          !url.includes("CORS-ANYWHERE.HEROKUAPP.COM")
        ) {
          router.push({
            path: "/notfound"
          });
        }
      }
    } else {
      displayInfo("Brak połączenia z serwerem");
    }
    return Promise.reject(error);
  }
);

Vue.$http = Axios;
Vue.prototype.$http = Axios;

export default Axios;
